var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pop-class"},[_c('p',{staticClass:"pop-class-title"},[_vm._v("热门课程")]),_c('ul',_vm._l((_vm.list),function(item){return _c('CardItem',{key:item.id,attrs:{"info":item}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }